import pkg from '../../package.json';
const { version } = pkg;

const VERSION_KEY = 'app_version';

/**
 * Limpa todos os caches do navegador:
 * - localStorage (exceto a chave de versão)
 * - sessionStorage
 * - Cache API (service workers / PWA)
 */
async function clearAllCaches() {
  // Limpa localStorage mantendo apenas a nova versão
  localStorage.clear();

  // Limpa sessionStorage
  sessionStorage.clear();

  // Limpa Cache API (PWA / service worker caches)
  if ('caches' in window) {
    const cacheNames = await caches.keys();
    await Promise.all(cacheNames.map((name) => caches.delete(name)));
  }

  // Registra a nova versão após limpar tudo
  localStorage.setItem(VERSION_KEY, version);
}

/**
 * Verifica se a versão atual é diferente da armazenada no navegador.
 * Caso seja nova versão, limpa o cache e recarrega a página.
 */
export async function checkAndBustCache() {
  const storedVersion = localStorage.getItem(VERSION_KEY);

  if (storedVersion === version) {
    // Mesma versão, nada a fazer
    return;
  }

  console.info(
    `[Cache] Nova versão detectada: ${storedVersion ?? 'nenhuma'} → ${version}. Limpando cache...`
  );

  await clearAllCaches();

  // Força recarregamento ignorando cache do browser
  window.location.reload(true);
}
